import { Typography } from '@mui/material';
import _ from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import {
  ResourceType,
  useInstitutionalResources,
} from '../../hooks/useInstitutionalResources';
import VegaSearchBy from '../common/VegaSearchBy';
import VegaTable from '../common/VegaTable';
import { VegaCard } from '../common';

function CountryCodeTable() {
  const { loading, fetchResource } = useInstitutionalResources();
  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowCount, setRowCount] = useState<number>(0);
  const [filter, setFilter] = useState<{ search: string; searchBy: string }>({
    search: '',
    searchBy: COUNTRY_COLUMNS[0].value,
  });

  async function fetchCountryCodes() {
    try {
      const response = await fetchResource<any>({
        type: ResourceType.COUNTRY_CODE,
        page: page,
        pageSize: pageSize,
        searchBy: filter.searchBy,
        searchQuery: filter.search,
      });
      setCountryCodes(response.records);
      setRowCount(response.totalItems);
    } catch (error) {}
  }

  const onFilterChange = (name: string, value: string) => {
    if (name === 'searchBy') {
      setFilter((preVal: any) => ({
        ...preVal,
        ['search']: '',
        ['searchBy']: value,
      }));
    } else {
      setFilter((preVal: any) => ({
        ...preVal,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    fetchCountryCodes();
  }, [page, pageSize, filter.search, filter.searchBy]);

  return (
    <Fragment>
      <VegaSearchBy
        placeholder="Search"
        data={COUNTRY_COLUMNS}
        searchByname="searchBy"
        searchName="search"
        key="search"
        state={filter}
        handleChange={onFilterChange}
      />
      <VegaCard noPad>
        <VegaTable
          data={countryCodes}
          columnDef={columnCountryCode}
          idColumn={'id'}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          page={page}
          pageSize={pageSize}
          rowCount={rowCount}
          paginationMode="server"
          loading={loading}
        />
      </VegaCard>
    </Fragment>
  );
}

export default CountryCodeTable;

const COUNTRY_COLUMNS = [
  {
    text: 'Country Name',
    value: 'country',
  },
  {
    text: 'ISO Code',
    value: 'countryCode',
  },
];

const columnCountryCode = [
  {
    field: 'country',
    headerName: '  Country Name',
    renderCell: (props: any) => {
      return <Typography>{_.capitalize(props.row.country)}</Typography>;
    },
    flex: 1,
  },

  {
    field: 'countryCode',
    headerName: '  ISO Code',
    renderCell: (props: any) => {
      return <Typography>{props.row.countryCode?.toUpperCase()}</Typography>;
    },
    flex: 1,
  },
];
